import React, { useState, useContext, useEffect, useRef } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import openSocket from 'socket.io-client'
import FilterPanel from '../../components/organisms/FilterPanel'
import GridView from '../../components/molecules/ProductCard/GridView'
import './Search.css'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import { Button, MenuItem } from '@material-ui/core'
import ListView from '../../components/molecules/ProductCard/ListView'
import Drawer from '@material-ui/core/Drawer'
// import ProductView from '../../components/organisms/ProductView'
import ProductContext from '../../context/product/productContext'
import AuthContext from '../../context/auth/authContext'
import AlertContext from '../../context/alert/alertContext'
import CommonContext from '../../context/common/commonContext'
import { Pagination } from '@material-ui/lab'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import { useFormik } from 'formik'
import Banner from '../../components/molecules/Banner'
import AuctionOfTheWeek from '../../components/molecules/AuctionOfTheWeek'
import { messageHandler } from '../Common/socketHandler'
import { handleRedirectInternal, useCustomMediaQuery } from '../../common/components'
import SearchNav from '../../components/molecules/SearchNav'
import Loader from '../../components/molecules/Loader'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import Seo from '../../components/molecules/Seo'
import { useLocation } from 'react-router-dom'
import useAwardedProducts from './useAwardedProducts'
import useFlipList from './useFlipList'
import {
    CLOSING_NOTICE_MS,
    isCloseDebugEnabled,
    logClose,
    normalizeProductId,
} from '../../common/closedProducts'

const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})
const OUTLET_THEME_CLASS = 'search-outlet-theme'
const getResultSetSignature = (payload) =>
    JSON.stringify(
        Object.entries(payload)
            .filter(([key]) => !['page', 'pagecom', 'sh_limit'].includes(key))
            .sort(([left], [right]) => left.localeCompare(right)),
    )
const getProductId = (product) =>
    [product?.id, product?.pid, product?.product_id].map(normalizeProductId).find(Boolean)

const Search = () => {
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const commonContext = useContext(CommonContext)
    const { setSearchValue, searchValue, phrase } = commonContext
    const { type } = useParams()
    const params = new URLSearchParams(window.location.search.substring(1))
    const [completed, setCompleted] = useState(type === 'completed')
    const location = useLocation()

    const classes = useStyles()
    const history = useHistory()
    const {
        search_allproducts,
        getAllSearchProducts,
        responseStatus,
        getProjectsMain,
        getProjectsMainPage,
        getProjectsSpotlight,
        projectsMain_spotlight,
        projectsMain,
        getProjectsCompleted,
        projectCompleted,
        dispatchSelectedCategories,
        selectedCategories,
        projmainloading,
        projcompletedloading,
    } = productContext

    const { user, isAuthenticated, saveSearch } = authContext

    const { setAlert } = alertContext
    const isOutlet = window.location.pathname == '/search/outlet'

    const [auctionView, setAuctionView] = useState('Grid')
    const [state, setState] = useState({
        right: false,
        bottom: false,
        left: false,
        data: {},
    })
    let [viewSpotlightProduct, setViewSpotlightProduct] = useState([])
    const viewSpotlightProductRef = useRef(viewSpotlightProduct)
    viewSpotlightProductRef.current = viewSpotlightProduct
    const spotlightProductRef = useRef(null)
    let [viewProduct, setViewProduct] = useState([])
    const viewProductRef = useRef(viewProduct)
    viewProductRef.current = viewProduct
    const userRef = useRef(user)
    let [outletCount, setOutletCount] = useState([])
    let [projectsMainCompleted, setProjectsMainCompleted] = useState([])
    const [socketRecentlyClosed, setSocketRecentlyClosed] = useState([])
    const handledRecentlyClosedRef = useRef(new Set())
    const closingProductSnapshotsRef = useRef(new Map())
    const [spotlightProduct, setSpotlightProduct] = useState(null)
    const { awardStates, closedProducts, withUpdatedDates } = useAwardedProducts()
    const closedProductsRef = useRef(closedProducts)
    closedProductsRef.current = closedProducts
    const [liveTotalRecords, setLiveTotalRecords] = useState(null)
    const [socketListChanged, setSocketListChanged] = useState(false)
    const [loadedSearchRequestKey, setLoadedSearchRequestKey] = useState(null)
    const handledClosuresRef = useRef(new Set())
    const replacementQueueRef = useRef([])
    const replacementInFlightRef = useRef(false)
    const reservedReplacementIdsRef = useRef(new Set())
    const countedClosuresRef = useRef(new Set())
    const serverTotalRecordsRef = useRef(null)
    const closedNoticeText = (productId) =>
        closedProducts[productId]?.reason === 'award'
            ? phrase.auction_ended_early || 'Auction ended early'
            : phrase.auction_ended || 'Auction ended'
    const activeProducts = viewProduct
        .filter((product) => awardStates[product.id] !== 'removed')
        .map(withUpdatedDates)
    const [spotlightPhase, setSpotlightPhase] = useState('idle')
    const [nextSpotlight, setNextSpotlight] = useState(null)
    const [spotlightRemovalNotice, setSpotlightRemovalNotice] = useState(false)
    const [spotlightHeight, setSpotlightHeight] = useState(null)
    const spotlightSectionRef = useRef(null)
    const spotlightTransitionRef = useRef(false)
    const spotlightRevisionRef = useRef(0)
    const [pendingSpotlightUpdate, setPendingSpotlightUpdate] = useState(null)
    const pendingSpotlightUpdateRef = useRef(null)
    pendingSpotlightUpdateRef.current = pendingSpotlightUpdate
    const spotlightUpdateHandlerRef = useRef(null)
    spotlightUpdateHandlerRef.current = (data) => {
        if (!['add', 'replace', 'remove'].includes(data?.action_type)) {
            console.error('[spotlight_updated] Invalid action_type', data?.action_type)
            return
        }
        if (
            !/^[1-9]\d*$/.test(String(data.productId)) ||
            (data.action_type !== 'remove' &&
                (!data.product ||
                    typeof data.product !== 'object' ||
                    String(data.product.id) !== String(data.productId)))
        ) {
            console.error('[spotlight_updated] Invalid product', data)
            return
        }
        spotlightRevisionRef.current += 1
        spotlightTransitionRef.current = true
        setPendingSpotlightUpdate(data.action_type === 'remove' ? [] : [data.product])
    }
    const spotlightMountedRef = useRef(true)
    useEffect(() => {
        spotlightMountedRef.current = true
        return () => {
            spotlightMountedRef.current = false
        }
    }, [])
    const activeSpotlightProducts = viewSpotlightProduct
    const refreshedSpotlightIds = useRef(new Set())
    const removedSpotlightId = viewSpotlightProduct[0]?.id
    useEffect(() => {
        if (
            completed ||
            isOutlet ||
            !awardStates[removedSpotlightId] ||
            refreshedSpotlightIds.current.has(String(removedSpotlightId))
        ) {
            return
        }

        refreshedSpotlightIds.current.add(String(removedSpotlightId))
        spotlightTransitionRef.current = true
        setNextSpotlight(null)
        setSpotlightHeight(spotlightSectionRef.current?.getBoundingClientRect().height || null)
        setSpotlightPhase('waiting')
        const revision = spotlightRevisionRef.current
        logClose(`spotlight ${removedSpotlightId} closed, requesting next spotlight`)
        getProjectsSpotlight(undefined, false)
            .then((products) => {
                logClose(
                    'next spotlight response',
                    (products || []).map((product) => product.id),
                    { stale: revision !== spotlightRevisionRef.current },
                )
                if (!spotlightMountedRef.current || revision !== spotlightRevisionRef.current)
                    return
                setNextSpotlight(
                    products.filter(
                        (product) => !refreshedSpotlightIds.current.has(String(product.id)),
                    ),
                )
            })
            .catch((error) => {
                console.error('[product_updated] Failed to refresh spotlight auction', error)
                if (!spotlightMountedRef.current || revision !== spotlightRevisionRef.current)
                    return
                setAlert(
                    phrase.something_went_wrong || 'Unable to load the next spotlight auction.',
                    'error',
                )
            })
    }, [
        awardStates,
        removedSpotlightId,
        completed,
        isOutlet,
        getProjectsSpotlight,
        setAlert,
        phrase,
    ])
    useEffect(() => {
        if (pendingSpotlightUpdate === null || !['idle', 'waiting'].includes(spotlightPhase)) return

        const products = pendingSpotlightUpdate.filter((product) => !awardStates[product.id])
        setPendingSpotlightUpdate(null)
        setNextSpotlight(products)
        if (viewSpotlightProduct.length) {
            const showRemovalNotice =
                !products.length &&
                spotlightPhase === 'idle' &&
                !awardStates[viewSpotlightProduct[0].id]
            setSpotlightHeight(spotlightSectionRef.current?.getBoundingClientRect().height || null)
            setSpotlightRemovalNotice(showRemovalNotice)
            setSpotlightPhase(
                products.length ? 'exiting' : showRemovalNotice ? 'removing' : 'collapsing',
            )
        } else if (products.length) {
            setViewSpotlightProduct(products)
            setSpotlightProduct(products[0])
            setSpotlightHeight(0)
            setSpotlightPhase('adding')
        } else {
            spotlightTransitionRef.current = false
        }
    }, [pendingSpotlightUpdate, spotlightPhase, viewSpotlightProduct, awardStates])

    useEffect(() => {
        logClose(`spotlight phase: ${spotlightPhase}`)
    }, [spotlightPhase])

    useEffect(() => {
        if (spotlightPhase !== 'adding') return
        const frame = requestAnimationFrame(() => {
            setSpotlightHeight(spotlightSectionRef.current?.scrollHeight || null)
        })
        return () => cancelAnimationFrame(frame)
    }, [spotlightPhase])

    useEffect(() => {
        if (
            spotlightPhase !== 'waiting' ||
            pendingSpotlightUpdate !== null ||
            nextSpotlight === null ||
            awardStates[removedSpotlightId] !== 'removed'
        )
            return
        setSpotlightPhase(nextSpotlight.length ? 'exiting' : 'collapsing')
    }, [spotlightPhase, nextSpotlight, awardStates, removedSpotlightId, pendingSpotlightUpdate])

    useEffect(() => {
        if (!['removing', 'exiting', 'entering', 'collapsing', 'adding'].includes(spotlightPhase))
            return
        const timer = setTimeout(
            () => {
                if (spotlightPhase === 'removing') {
                    setSpotlightPhase('collapsing')
                } else if (spotlightPhase === 'exiting') {
                    setViewSpotlightProduct(nextSpotlight)
                    setSpotlightProduct(nextSpotlight[0])
                    setSpotlightPhase('entering')
                } else {
                    if (spotlightPhase === 'collapsing') {
                        setViewSpotlightProduct([])
                        setSpotlightProduct(null)
                    }
                    spotlightTransitionRef.current = pendingSpotlightUpdateRef.current !== null
                    setSpotlightPhase('idle')
                    setSpotlightHeight(null)
                    setNextSpotlight(null)
                    setSpotlightRemovalNotice(false)
                }
            },
            spotlightPhase === 'removing' ? CLOSING_NOTICE_MS : 800,
        )
        return () => clearTimeout(timer)
    }, [spotlightPhase, nextSpotlight])
    const resultsContainerRef = useRef(null)
    const displayedProducts = activeProducts.filter(
        (item) =>
            isOutlet ||
            activeSpotlightProducts.length === 0 ||
            item.id !== activeSpotlightProducts[0]?.id,
    )
    useFlipList(
        resultsContainerRef,
        displayedProducts.map((product) => product.id),
        auctionView,
    )
    const closingNotice = (product) =>
        awardStates[product.id] === 'closing' ? (
            <div className="auctionAwardNotice" role="status" aria-live="polite">
                <span className="material-icons" aria-hidden="true">
                    gavel
                </span>
                <strong>{closedNoticeText(product.id)}</strong>
            </div>
        ) : null
    const [projectsMainPayload, setProjectsMainPayload] = useState({
        ajax: 1,
        sh_limit: 45,
        orderby: searchValue.orderby ? searchValue.orderby : 3,
        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
        page: 1,
        pagecom: 1,
        condition: '',
        lottype: '',
        category: '',
        view: '',
        listfmt: '',
        listfmtnew: '',
        reglist: '',
        countrylist: '',
        auction_format: isOutlet ? 'outlet' : 'normal',
    })
    const projectsMainPayloadRef = useRef(projectsMainPayload)
    projectsMainPayloadRef.current = projectsMainPayload
    const resultSetSignature = getResultSetSignature(projectsMainPayload)
    const resultSetSignatureRef = useRef(null)
    // search form for ended auctions
    const [endedProjectsPayload, setEndedProjectsPayload] = useState({
        ajax: 1,
        sh_limit: completed ? 45 : 6,
        orderby: searchValue.orderby ? searchValue.orderby : 3,
        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
        page: 1,
        pagecom: 1,
        condition: '',
        lottype: '',
        category: '',
        view: '',
        listfmt: '',
        listfmtnew: '',
        reglist: '',
        countrylist: '',
        auction_format: isOutlet ? 'outlet' : 'normal',
    })
    let [pageOptionsSelected, setPageOptionsSelected] = useState({
        value: 45,
    })
    // 3 is default for Price Low - High
    let [sortShowSelected, setShortshowSelected] = useState({
        value: searchValue.orderby ? searchValue.orderby : 3,
    })
    const [bannerList, setBannerList] = useState([])

    const pageOptions = [
        {
            value: '15',
            show: '15',
        },
        {
            value: '30',
            show: '30',
        },
        {
            value: '45',
            show: '45',
        },
    ]

    const sortShow = [
        {
            value: 1,
            show: phrase.ending_soon,
        },
        {
            value: 2,
            show: phrase.newly_added,
        },
        {
            value: 3,
            show: phrase.price_low_high,
        },
        {
            value: 4,
            show: phrase.price_high_low,
        },
    ]

    const formik = useFormik({
        initialValues: {
            searchbar: '',
        },
    })
    const totalRecordsForDisplay = liveTotalRecords ?? Number(projectsMain?.totalRecords || 0)
    const searchRequestKey = JSON.stringify(projectsMainPayload)
    const searchResultsReady = completed || loadedSearchRequestKey === searchRequestKey
    const totalPages =
        totalRecordsForDisplay && projectsMainPayload?.sh_limit
            ? Math.ceil(totalRecordsForDisplay / projectsMainPayload.sh_limit)
            : 0
    const displaySetDisp = socketListChanged
        ? (() => {
              const limit = Number(projectsMainPayload.sh_limit)
              const start = (Number(projectsMainPayload.page) - 1) * limit + 1
              const count = activeProducts.length
              return count
                  ? `${start}-${Math.min(start + count - 1, totalRecordsForDisplay)}`
                  : '0-0'
          })()
        : projectsMain.set_disp
    const showRecentlyClosedAuctionsSection =
        projcompletedloading ||
        Number(projectCompleted?.totalRecords || 0) > 0 ||
        projectsMainCompleted.length > 0 ||
        (!completed &&
            socketRecentlyClosed.some((entry) => entry.resultSetSignature === resultSetSignature))
    const serverRecentlyClosedIds = new Set(
        (projectCompleted?.projcompletedArr || []).map(getProductId).filter(Boolean),
    )
    const currentSocketRecentlyClosed = socketRecentlyClosed
        .filter((entry) => entry.resultSetSignature === resultSetSignature)
        .map((entry) => entry.product)
    const recentlyClosedProducts = [
        ...currentSocketRecentlyClosed,
        ...projectsMainCompleted.filter(
            (product) =>
                !currentSocketRecentlyClosed.some(
                    (localProduct) => getProductId(localProduct) === getProductId(product),
                ),
        ),
    ].slice(0, 6)
    const socketClosuresMissingFromApi = socketRecentlyClosed.filter(
        (entry) =>
            entry.resultSetSignature === resultSetSignature &&
            !serverRecentlyClosedIds.has(normalizeProductId(entry.product.id)),
    ).length
    const recentlyClosedTotal =
        Number(projectCompleted?.totalRecords || 0) + socketClosuresMissingFromApi
    const recentlyClosedSetDisp =
        socketClosuresMissingFromApi || socketListChanged
            ? recentlyClosedProducts.length
                ? `1-${Math.min(recentlyClosedProducts.length, recentlyClosedTotal)}`
                : '0-0'
            : projectCompleted?.set_disp

    useEffect(() => {
        if (isOutlet) {
            document.body.classList.add(OUTLET_THEME_CLASS)
        } else {
            document.body.classList.remove(OUTLET_THEME_CLASS)
        }

        return () => {
            document.body.classList.remove(OUTLET_THEME_CLASS)
        }
    }, [isOutlet])

    // user hit keys on top keyword search input
    const handleKeyDown = (event) => {
        let { key } = event
        let { value } = event.target
        setSearchValue({ ...searchValue, searchbar: value })
        if (key === 'Enter') {
            let payload = {
                ...projectsMainPayload,
                searchbar: value,
            }
            setProjectsMainPayload(payload)
            setEndedProjectsPayload(payload)
        }
    }
    useEffect(() => {
        const auctionFormat = isOutlet ? 'outlet' : 'normal'
        setProjectsMainPayload((prev) =>
            prev.auction_format === auctionFormat && prev.page === 1
                ? prev
                : { ...prev, auction_format: auctionFormat, page: 1 },
        )
        setEndedProjectsPayload((prev) =>
            prev.auction_format === auctionFormat && prev.page === 1 && prev.pagecom === 1
                ? prev
                : { ...prev, auction_format: auctionFormat, page: 1, pagecom: 1 },
        )
    }, [isOutlet])
    // user hit on search icon on top bar
    const searchBarSubmit = () => {
        let payload = {
            ...projectsMainPayload,
            searchbar: searchValue.searchbar,
        }
        setProjectsMainPayload(payload)
        setEndedProjectsPayload(payload)
    }

    useEffect(() => {
        document.title = global.site_title + ' | Search'
        getAllSearchProducts({}, 'search')
    }, [])

    useEffect(() => {
        if (
            typeof search_allproducts.banner !== 'undefined' &&
            search_allproducts.banner.length > 0
        ) {
            setBannerList(search_allproducts.banner)
        }
    }, [search_allproducts])

    const updateAuctionOfWeek = (prev, message, type) => {
        if (!prev) {
            return prev
        }
        if (prev.id !== message.id) {
            return prev
        }
        const updated = { ...prev }
        if (type === 'bidAddtime') {
            if (message.bpop_wprice) updated.wprice = message.bpop_wprice
            if (message.date_closed) updated.date_closed = message.date_closed
        }
        return updated
    }
    useEffect(() => {
        if (
            completed ||
            !Object.keys(projectsMainPayload).length ||
            projectsMainPayload.auction_format !== (isOutlet ? 'outlet' : 'normal')
        )
            return

        let isCurrentRequest = true
        const requestKey = JSON.stringify(projectsMainPayload)
        setLoadedSearchRequestKey(null)

        Promise.all([getProjectsMain(projectsMainPayload), getProjectsSpotlight()])
            .then(([, spotlightProducts]) => {
                if (!isCurrentRequest) return
                const availableSpotlightProducts = (
                    Array.isArray(spotlightProducts) ? spotlightProducts : []
                ).filter((product) => !closedProductsRef.current[normalizeProductId(product.id)])
                if (!spotlightTransitionRef.current) {
                    setViewSpotlightProduct(availableSpotlightProducts)
                    setSpotlightProduct(availableSpotlightProducts[0] || null)
                    spotlightProductRef.current = availableSpotlightProducts[0] || null
                }
                setLoadedSearchRequestKey(requestKey)
            })
            .catch((error) => {
                console.error('[search] Failed to load initial search results', error)
                if (!isCurrentRequest) return
                setLoadedSearchRequestKey(requestKey)
                setAlert(phrase.something_went_wrong || 'Unable to load search results.', 'error')
            })

        return () => {
            isCurrentRequest = false
        }
    }, [projectsMainPayload, completed, isOutlet])

    const initialLoadEndedProjects = useRef(true)

    useEffect(() => {
        if (initialLoadEndedProjects.current) {
            initialLoadEndedProjects.current = false
            return
        }

        if (!Object.keys(endedProjectsPayload).length) return

        if (completed) {
            getProjectsCompleted(endedProjectsPayload)
        } else {
            getProjectsCompleted({
                ...endedProjectsPayload,
                sh_limit: 6,
                pagecom: 1,
            })
        }
    }, [endedProjectsPayload, completed])
    useEffect(() => {
        const interval = setInterval(() => {
            const btn = document.querySelector('.outletBtn button.MuiButton-containedPrimary')
            if (!btn) return

            btn.classList.remove('pulse')
            void btn.offsetWidth // restart animation
            btn.classList.add('pulse')
        }, 3000)
        return () => clearInterval(interval)
    }, [])

    // loaded active auctions
    useEffect(() => {
        if (
            typeof projectsMain.projectsMainArr !== 'undefined' &&
            Array.isArray(projectsMain.projectsMainArr)
        ) {
            const responseTotal = Number(projectsMain.totalRecords || 0)
            const closedInResponse = new Set(
                projectsMain.projectsMainArr
                    .map((product) => normalizeProductId(product.id))
                    .filter((id) => id && closedProductsRef.current[id]?.status === 'removed'),
            )
            if (resultSetSignatureRef.current !== resultSetSignature) {
                resultSetSignatureRef.current = resultSetSignature
                countedClosuresRef.current.clear()
                serverTotalRecordsRef.current = responseTotal
                setLiveTotalRecords(Math.max(0, responseTotal - closedInResponse.size))
                setSocketListChanged(false)
                reservedReplacementIdsRef.current.clear()
            } else {
                const reflectedIds = new Set()
                let reflectedClosures = Math.max(
                    0,
                    (serverTotalRecordsRef.current ?? responseTotal) - responseTotal,
                )
                for (const id of countedClosuresRef.current) {
                    if (!reflectedClosures) break
                    countedClosuresRef.current.delete(id)
                    reflectedIds.add(id)
                    reflectedClosures -= 1
                }
                serverTotalRecordsRef.current = responseTotal
                const staleClosedCount = [...closedInResponse].filter(
                    (id) => !countedClosuresRef.current.has(id) && !reflectedIds.has(id),
                ).length
                setLiveTotalRecords(
                    Math.max(0, responseTotal - countedClosuresRef.current.size - staleClosedCount),
                )
            }
            setOutletCount(projectsMain.outletAuctionsCount)
            viewProductRef.current = projectsMain.projectsMainArr
            setViewProduct(projectsMain.projectsMainArr)
        }
    }, [projectsMain])
    useEffect(() => {
        if (
            !spotlightTransitionRef.current &&
            Array.isArray(projectsMain_spotlight?.projectsMainArr)
        ) {
            setViewSpotlightProduct(projectsMain_spotlight.projectsMainArr)
            setSpotlightProduct(projectsMain_spotlight.projectsMainArr[0] || null)
            spotlightProductRef.current = projectsMain_spotlight.projectsMainArr[0] || null
        }
    }, [projectsMain_spotlight])

    // loaded ended auctions
    useEffect(() => {
        if (typeof projectCompleted !== 'undefined' && Object.keys(projectCompleted).length) {
            if (typeof projectCompleted.projcompletedArr !== 'undefined') {
                setProjectsMainCompleted(projectCompleted.projcompletedArr)
            }
        }
    }, [projectCompleted])

    useEffect(() => {
        userRef.current = user
    })

    useEffect(() => {
        spotlightProductRef.current = spotlightProduct
    }, [spotlightProduct])

    const handler = (message, type, noBadge = false) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
            noBadge,
        )
        setSpotlightProduct((prev) => {
            return updateAuctionOfWeek(prev, message, type)
        })
    }

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'watchlist') {
                handler(
                    {
                        id: responseStatus.data.project_id,
                        status: responseStatus.data.status,
                    },
                    'watchlistAdded',
                )
            }
        }
    }, [responseStatus])

    useEffect(() => {
        if (isCloseDebugEnabled() && Object.keys(closedProducts).length) {
            const visibleIds = viewProductRef.current.map((product) => String(product.id))
            const spotlightIds = viewSpotlightProduct.map((product) => String(product.id))
            Object.entries(closedProducts).forEach(([id, { status }]) => {
                logClose(
                    `search page: id ${id} is ${status};`,
                    visibleIds.includes(id)
                        ? 'found in grid/list'
                        : spotlightIds.includes(id)
                        ? 'found in spotlight'
                        : 'NOT on this page',
                )
            })
            logClose('search page visible ids', { grid: visibleIds, spotlight: spotlightIds })
        }
        const isNewlyClosed = (product) =>
            product && closedProducts[product.id] && product.market_status === 'open'
        const markClosed = (product) =>
            isNewlyClosed(product) ? { ...product, market_status: 'closed' } : product
        setViewProduct((previous) =>
            previous.some(isNewlyClosed) ? previous.map(markClosed) : previous,
        )
        setViewSpotlightProduct((previous) =>
            previous.some(isNewlyClosed) ? previous.map(markClosed) : previous,
        )
        setSpotlightProduct(markClosed)
    }, [closedProducts])

    useEffect(() => {
        if (completed) return

        Object.entries(closedProducts).forEach(([id, state]) => {
            if (state.status === 'closing' && !closingProductSnapshotsRef.current.has(id)) {
                const product =
                    viewProductRef.current.find((item) => getProductId(item) === id) ||
                    viewSpotlightProductRef.current.find((item) => getProductId(item) === id) ||
                    (getProductId(spotlightProductRef.current) === id
                        ? spotlightProductRef.current
                        : null)
                if (product) {
                    closingProductSnapshotsRef.current.set(id, {
                        product: { ...product, market_status: 'closed' },
                        resultSetSignature: getResultSetSignature(projectsMainPayloadRef.current),
                    })
                }
            }

            if (state.status !== 'removed' || handledClosuresRef.current.has(id)) return
            const product =
                viewProductRef.current.find((item) => getProductId(item) === id) ||
                viewSpotlightProductRef.current.find((item) => getProductId(item) === id) ||
                (getProductId(spotlightProductRef.current) === id
                    ? spotlightProductRef.current
                    : null)

            handledClosuresRef.current.add(id)
            if (!handledRecentlyClosedRef.current.has(id)) {
                const snapshot = closingProductSnapshotsRef.current.get(id)
                const closedProduct = snapshot?.product || product
                const snapshotSignature =
                    snapshot?.resultSetSignature ||
                    getResultSetSignature(projectsMainPayloadRef.current)
                if (closedProduct) {
                    handledRecentlyClosedRef.current.add(id)
                    setSocketRecentlyClosed((previous) =>
                        [
                            {
                                product: { ...closedProduct, market_status: 'closed' },
                                resultSetSignature: snapshotSignature,
                            },
                            ...previous.filter((entry) => getProductId(entry.product) !== id),
                        ].slice(0, 6),
                    )
                    Promise.resolve()
                        .then(() =>
                            getProjectsCompleted({
                                ...projectsMainPayloadRef.current,
                                sh_limit: 6,
                                page: 1,
                                pagecom: 1,
                            }),
                        )
                        .catch((error) => {
                            console.error(
                                '[auction-close] Failed to refresh recently closed auctions',
                                error,
                            )
                            setAlert(
                                phrase.something_went_wrong ||
                                    'Unable to refresh recently closed auctions.',
                                'error',
                            )
                        })
                    logClose(`moving closed product ${id} to Recently Closed Auctions`)
                }
            }

            const currentPage = Number(projectsMainPayloadRef.current.page) || 1
            const pageLimit = Number(projectsMainPayloadRef.current.sh_limit) || 0
            const previousTotal =
                liveTotalRecords === null
                    ? Number(projectsMain.totalRecords || 0)
                    : liveTotalRecords
            if (
                viewProductRef.current.some((item) => getProductId(item) === id) &&
                !countedClosuresRef.current.has(id)
            ) {
                countedClosuresRef.current.add(id)
                setSocketListChanged(true)
                setLiveTotalRecords((current) => Math.max(0, (current ?? previousTotal) - 1))
            }

            const request = {
                id,
                replaceSlot: viewProductRef.current.some((item) => getProductId(item) === id),
                payload: { ...projectsMainPayloadRef.current },
                resultSetSignature: getResultSetSignature(projectsMainPayloadRef.current),
                hasNextPage: pageLimit > 0 && currentPage * pageLimit < previousTotal,
                page: currentPage,
                previousTotal,
            }
            logClose(
                product
                    ? 'closed visible result; updating count and queueing replacement'
                    : 'closed result not on this page; queueing filtered count refresh',
                request,
            )
            if (request.replaceSlot ? request.hasNextPage : true) {
                const duplicateCountRequest =
                    !request.replaceSlot &&
                    replacementQueueRef.current.some(
                        (queued) =>
                            !queued.replaceSlot &&
                            queued.page === request.page &&
                            queued.resultSetSignature === request.resultSetSignature,
                    )
                if (!duplicateCountRequest) replacementQueueRef.current.push(request)
            }
        })

        if (replacementInFlightRef.current || replacementQueueRef.current.length === 0) return
        replacementInFlightRef.current = true

        const processQueue = async () => {
            while (replacementQueueRef.current.length) {
                const request = replacementQueueRef.current.shift()
                if (
                    request.resultSetSignature !==
                        getResultSetSignature(projectsMainPayloadRef.current) ||
                    request.page !== Number(projectsMainPayloadRef.current.page)
                )
                    continue

                try {
                    const pageLimit = Number(request.payload.sh_limit) || 1
                    const activePageIds = new Set(
                        viewProductRef.current
                            .map(getProductId)
                            .filter((id) => id && !closedProductsRef.current[id]),
                    )
                    const firstReplacementPosition = request.replaceSlot
                        ? (request.page - 1) * pageLimit +
                          Math.min(pageLimit, activePageIds.size) +
                          1
                        : 1
                    let pageResponse = null
                    let replacement = null
                    const findReplacement = (response) => {
                        const currentIds = new Set(viewProductRef.current.map(getProductId))
                        return response.projectsMainArr.find((item) => {
                            const id = getProductId(item)
                            return (
                                id &&
                                !currentIds.has(id) &&
                                !closedProductsRef.current[id] &&
                                !reservedReplacementIdsRef.current.has(id)
                            )
                        })
                    }
                    const firstPosition = request.replaceSlot ? firstReplacementPosition : 1
                    let lastPosition = request.replaceSlot
                        ? Math.max(
                              firstReplacementPosition,
                              serverTotalRecordsRef.current ?? request.previousTotal,
                          )
                        : firstPosition
                    for (let position = firstPosition; position <= lastPosition; position += 1) {
                        if (
                            request.resultSetSignature !==
                                getResultSetSignature(projectsMainPayloadRef.current) ||
                            request.page !== Number(projectsMainPayloadRef.current.page)
                        )
                            break
                        logClose('requesting single replacement candidate', {
                            closedId: request.id,
                            currentPage: request.page,
                            pageLimit,
                            position,
                            sh_limit: 1,
                        })
                        pageResponse = await getProjectsMainPage({
                            ...request.payload,
                            sh_limit: 1,
                            page: position,
                        })
                        replacement = request.replaceSlot ? findReplacement(pageResponse) : null
                        logClose('replacement candidate evaluated', {
                            closedId: request.id,
                            position,
                            returnedIds: pageResponse.projectsMainArr.map(getProductId),
                            selectedId: replacement ? getProductId(replacement) : null,
                            totalRecords: pageResponse.totalRecords,
                        })
                        if (
                            !request.replaceSlot ||
                            replacement ||
                            pageResponse.projectsMainArr.length === 0
                        )
                            break
                        if (Number.isFinite(pageResponse.totalRecords)) {
                            lastPosition = pageResponse.totalRecords
                        }
                    }

                    if (!pageResponse) continue
                    const responseTotal = Number.isFinite(pageResponse.totalRecords)
                        ? pageResponse.totalRecords
                        : request.previousTotal
                    if (
                        request.resultSetSignature !==
                            getResultSetSignature(projectsMainPayloadRef.current) ||
                        request.page !== Number(projectsMainPayloadRef.current.page)
                    )
                        continue
                    const responseClosedIds = new Set(
                        pageResponse.projectsMainArr
                            .map((item) => {
                                const id = getProductId(item)
                                return id && closedProductsRef.current[id]?.status === 'removed'
                                    ? id
                                    : null
                            })
                            .filter(Boolean),
                    )
                    const reflectedIds = new Set()
                    let reflectedClosures = Math.max(
                        0,
                        (serverTotalRecordsRef.current ?? responseTotal) - responseTotal,
                    )
                    for (const id of countedClosuresRef.current) {
                        if (!reflectedClosures) break
                        countedClosuresRef.current.delete(id)
                        reflectedIds.add(id)
                        reflectedClosures -= 1
                    }
                    serverTotalRecordsRef.current = responseTotal
                    const staleClosedCount = [...responseClosedIds].filter(
                        (id) => !countedClosuresRef.current.has(id) && !reflectedIds.has(id),
                    ).length
                    const effectiveTotal = Math.max(
                        0,
                        responseTotal - countedClosuresRef.current.size - staleClosedCount,
                    )
                    setLiveTotalRecords(effectiveTotal)
                    setSocketListChanged(true)

                    if (replacement) {
                        const replacementId = getProductId(replacement)
                        reservedReplacementIdsRef.current.add(replacementId)
                        const nextProducts = [...viewProductRef.current, replacement]
                        viewProductRef.current = nextProducts
                        setViewProduct(nextProducts)
                        logClose(
                            `replacement ${replacementId} added for closed result ${request.id}`,
                        )
                    } else {
                        logClose(`no replacement available for closed result ${request.id}`)
                    }
                } catch (error) {
                    console.error('[auction-close] Failed to replenish search results', error)
                    setAlert(
                        phrase.something_went_wrong || 'Unable to refresh search results.',
                        'error',
                    )
                }
            }
            replacementInFlightRef.current = false
        }
        processQueue()
    }, [
        closedProducts,
        completed,
        getProjectsCompleted,
        getProjectsMainPage,
        liveTotalRecords,
        projectsMain.totalRecords,
        setAlert,
        phrase,
    ])

    useEffect(() => {
        if (projmainloading) return
        const page = Number(projectsMainPayload.page) || 1
        const lastPage = Math.max(1, totalPages)
        if (page > lastPage) {
            setProjectsMainPayload((current) => ({ ...current, page: lastPage }))
        }
    }, [projmainloading, projectsMainPayload.page, totalPages])

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, { transports: ['websocket'] })
        const onBidAddtime = (data) => {
            handler(data, 'bidAddtime', true)
        }
        const onDropPrice = (data) => {
            handler(data, 'drop_price')
        }
        const onCancelBidEmitted = (data) => {
            cancelBidHandler(data)
        }
        const onBidExtended = (data) => {
            handler(data, 'bid_extended')
        }
        const onSpotlightUpdated = (data) => spotlightUpdateHandlerRef.current(data)

        socket.on('bidAddtime', onBidAddtime)
        socket.on('drop_price', onDropPrice)

        socket.on('cancelbidemitted', onCancelBidEmitted)
        socket.on('bid_extended', onBidExtended)
        socket.on('spotlight_updated', onSpotlightUpdated)

        return () => {
            socket.off('bidAddtime', onBidAddtime)
            socket.off('drop_price', onDropPrice)
            socket.off('cancelbidemitted', onCancelBidEmitted)
            socket.off('bid_extended', onBidExtended)
            socket.off('spotlight_updated', onSpotlightUpdated)
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        if (state.right) {
            const index = viewProduct.findIndex((s) => s.id == parseInt(state.data.id, 10))
            if (index !== -1) {
                setState({ ...state, data: viewProduct[index] })
            }
        }
    }, [viewProduct])

    const fromArrToStr = (arr, type, isName, isregion) => {
        return arr
            .filter((ele) => {
                if (isregion) return ele.type === type && typeof ele.country === 'undefined'
                return ele.type === type
            })
            .map((ele) => {
                return ele.filterBy
                //return isName ? ele.name : ele.id
            })
            .join()
    }

    // page changed - active auctions
    const onHandlePage = (event, value) => {
        setProjectsMainPayload({ ...projectsMainPayload, page: value })
    }

    // page changed - ended auctions
    const onHandlePageEndedAuctions = (event, value) => {
        setEndedProjectsPayload({ ...endedProjectsPayload, page: value, pagecom: value })
    }

    useEffect(() => {
        if (typeof projectsMainPayload !== 'undefined') {
            if (Object.keys(projectsMainPayload).length) {
                if (Array.isArray(selectedCategories) && selectedCategories.length) {
                    let category = fromArrToStr(selectedCategories, 'category', 0, 0)
                    let sub_category = fromArrToStr(selectedCategories, 'sub_category', 0, 0)
                    let condition = fromArrToStr(selectedCategories, 'condition', 0, 0)
                    let listfmt = fromArrToStr(selectedCategories, 'listing', 1, 0)
                    let reglist = fromArrToStr(selectedCategories, 'region', 0, 1)
                    let countrylist = fromArrToStr(selectedCategories, 'region', 0, 0)
                    let lottype = fromArrToStr(selectedCategories, 'lot', 1, 0)
                    let payload = {
                        ...projectsMainPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: category,
                        sub_category,
                        condition: condition,
                        listfmt: listfmt,
                        reglist: reglist,
                        countrylist: countrylist,
                        lottype: lottype,
                        page: 1,
                    }
                    let payloadEndedAuctions = {
                        ...endedProjectsPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: category,
                        sub_category,
                        condition: condition,
                        listfmt: listfmt,
                        reglist: reglist,
                        countrylist: countrylist,
                        lottype: lottype,
                        page: 1,
                    }
                    setProjectsMainPayload(payload)
                    setEndedProjectsPayload(payloadEndedAuctions)
                }
                // no filter selected
                else {
                    let payload = {
                        ...projectsMainPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: '',
                        sub_category: '',
                        condition: '',
                        listfmt: '',
                        reglist: '',
                        countrylist: '',
                        lottype: '',
                        page: 1,
                    }
                    let payloadEndedAuctions = {
                        ...endedProjectsPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: '',
                        sub_category: '',
                        condition: '',
                        listfmt: '',
                        reglist: '',
                        countrylist: '',
                        lottype: '',
                        page: 1,
                    }
                    setProjectsMainPayload(payload)
                    setEndedProjectsPayload(payloadEndedAuctions)
                }
            }
        }
    }, [selectedCategories])

    // show results - per page value changed
    const pageOptionIntialLoad = useRef(true)
    useEffect(() => {
        if (
            typeof pageOptionsSelected.value !== 'undefined' &&
            pageOptionIntialLoad.current == false
        ) {
            let payload = {
                ...projectsMainPayload,
                sh_limit: pageOptionsSelected.value,
            }
            let payloadEndedAuctions = {
                ...endedProjectsPayload,
                sh_limit: pageOptionsSelected.value,
            }
            setProjectsMainPayload(payload)
            setEndedProjectsPayload(payloadEndedAuctions)
        }
        // don't update the main payload initially
        else {
            pageOptionIntialLoad.current = false
        }
    }, [pageOptionsSelected.value])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const clearSearchFilter = () => {
        setSearchValue({ ...searchValue, searchbar: '' })
        dispatchSelectedCategories([])
        setProjectsMainPayload((prev) => ({
            ...prev,
            searchbar: '',
            category: '',
            sub_category: '',
            condition: '',
            listfmt: '',
            reglist: '',
            countrylist: '',
            lottype: '',
            page: 1,
            auction_format: isOutlet ? 'outlet' : 'normal',
        }))

        setEndedProjectsPayload((prev) => ({
            ...prev,
            searchbar: '',
            category: '',
            sub_category: '',
            condition: '',
            listfmt: '',
            reglist: '',
            countrylist: '',
            lottype: '',
            page: 1,
            auction_format: isOutlet ? 'outlet' : 'normal',
        }))

        formik.values.searchbar = ''
    }
    const searchFilterFunc = ({ id, name, type, country, filterBy }, isclearAll) => {
        if (isclearAll) {
            setShortshowSelected({ value: 3 }) // set the sort by to default
            dispatchSelectedCategories([])
            setSearchValue({ ...searchValue, searchbar: '' })
            return
        }
        let selcat = [...selectedCategories]
        const selectedInd = selcat.findIndex((ele) => ele.id.toString() === id.toString())
        if (selectedInd >= 0) {
            selcat.splice(selectedInd, 1)
        } else {
            selcat.push({
                id,
                name,
                type: type,
                country,
                filterBy: filterBy,
            })
        }
        dispatchSelectedCategories(selcat)
    }

    const perPageChange = (event) => {
        let { value } = event.target
        let payload = {
            ...projectsMainPayload,
            sh_limit: value,
            page: 1,
        }
        let payloadEndedAuctions = {
            ...endedProjectsPayload,
            sh_limit: value,
        }
        setProjectsMainPayload(payload)
        setEndedProjectsPayload(payloadEndedAuctions)
        setPageOptionsSelected({ value })
    }

    // sort by option changed
    const sortByChange = (event) => {
        let { value } = event.target
        let payload = {
            ...projectsMainPayload,
            orderby: value,
        }
        let payloadEndedAuctions = {
            ...endedProjectsPayload,
            orderby: value,
        }
        setProjectsMainPayload(payload)
        setEndedProjectsPayload(payloadEndedAuctions)
        setShortshowSelected({ value })
    }

    const seoOutlet = {
        title: `Search Outlet Auctions | LedMax Electronics`,
        description:
            'Search across Outlet Auctions and Main Auctions at LedMax Electronics. Quickly find available inventory, refurbished electronics, computer equipment, and auction listings from all categories in one place.',
        canonical: `${location.pathname}`,
        keywords:
            'search auctions, outlet auctions, main auctions, auction search, LedMax Electronics auctions, refurbished electronics auctions, computer auctions, wholesale electronics auctions, auction inventory search, online auctions, electronics marketplace',
    }

    const seoSearch = {
        title: `Search Wholesale Refurbished Computer Desktops | LedMax`,
        description:
            'Find wholesale refurbished computer desktops quickly at LedMax Electronics. Search our inventory of professionally tested desktop PCs from top brands, available at competitive bulk prices for businesses, schools, and resellers.',
        canonical: `${location.pathname}`,
        keywords:
            'search refurbished desktops, wholesale desktop search, refurbished computer desktops, bulk desktop computers, wholesale refurbished PCs, Dell refurbished desktops, HP refurbished desktops, Lenovo desktops, business desktop computers, desktop inventory search, wholesale electronics, LedMax Electronics search',
    }

    const seoCompleted = {
        title: `Recently Closed Auctions | LedMax Electronics`,
        description:
            'Browse recently closed auctions at LedMax Electronics. View completed auction listings, past inventory, and previously available refurbished electronics, computers, and IT equipment from Outlet Auctions and Main Auctions.',
        canonical: `${location.pathname}`,
        keywords:
            'recently closed auctions, closed auction listings, past auctions, completed auctions, auction history, outlet auctions, main auctions, refurbished electronics auctions, computer equipment auctions, wholesale electronics, LedMax Electronics',
    }

    const currentSeo = isOutlet ? seoOutlet : completed ? seoCompleted : seoSearch

    return (
        <>
            <Seo {...currentSeo} siteName={global.site_title} />
            <SearchNav
                searchFilterFunc={searchFilterFunc}
                sortByChange={sortByChange}
                searchBarValue={searchValue.searchbar}
                searchBarSubmit={searchBarSubmit}
                searchInv={handleKeyDown}
                completed={completed}
            />
            {/* )} */}
            <div
                className="search container-fluid "
                style={{
                    opacity: searchResultsReady ? 1 : 0,
                    pointerEvents: searchResultsReady ? undefined : 'none',
                }}
                aria-busy={!searchResultsReady}
            >
                <div className="searchCnt d-flex justify-content-start align-items-start customContainer">
                    <div className="searchLt"></div>
                    <div className="searchRt">
                        {!completed && isOutlet && (
                            <>
                                {' '}
                                <div className="d-flex justify-content-start">
                                    <Button
                                        className="backBtn my-2"
                                        onClick={() => history.goBack()}
                                    >
                                        <span className="material-icons">arrow_back</span>
                                        {phrase.back_to_main_auction || 'Back to Main Auction'}
                                    </Button>
                                </div>
                                <h2 className="outletAuction">
                                    <img
                                        src="/assets/images/outlet_banner.png"
                                        alt="Outlet ny Ledmax"
                                    />
                                </h2>
                            </>
                        )}
                        <div className="mb-3 searchTitleCnt d-flex justify-content-start align-items-center flex-wrap">
                            {!completed && (
                                <div className="searchTitle">
                                    <h3>
                                        {(() => {
                                            let a = sortShow.find(
                                                (ele) => ele.value === sortShowSelected.value,
                                            )
                                            return a.show
                                        })()}
                                    </h3>
                                    <h6>
                                        {displaySetDisp} OF {totalRecordsForDisplay} LOTS
                                    </h6>
                                </div>
                            )}
                            <div className="searchMiscFilters w-100 d-flex justify-content-end align-items-end">
                                <div className="gridListToggle">
                                    <Button
                                        className={auctionView === 'Grid' ? 'active' : ''}
                                        onClick={() => setAuctionView('Grid')}
                                    >
                                        <span className="material-icons">apps</span> {phrase.grid}
                                    </Button>
                                    <Button
                                        className={auctionView === 'List' ? 'active' : ''}
                                        onClick={() => setAuctionView('List')}
                                    >
                                        <span className="material-icons">view_list</span>
                                        {phrase.list}
                                    </Button>
                                </div>
                                <div className="rpe d-flex justify-content-between align-items-center">
                                    <label>{phrase.show_results}</label>
                                    <CustomSelect
                                        name="resultsPerPage"
                                        selectType="noBorder"
                                        size="small"
                                        onChange={perPageChange}
                                        value={pageOptionsSelected.value}
                                    >
                                        {pageOptions.map((opt, optindex) => (
                                            <MenuItem key={optindex} value={opt.value}>
                                                {opt.show}
                                            </MenuItem>
                                        ))}
                                    </CustomSelect>
                                </div>
                                <div className="sort d-flex justify-content-between align-items-center">
                                    <label>{phrase.sort_by}</label>
                                    <CustomSelect
                                        size="small"
                                        selectType="noBorder"
                                        name="orderby"
                                        // shrink={search.orderby !== '' ? true : false}
                                        onChange={sortByChange}
                                        value={sortShowSelected.value}
                                    >
                                        {sortShow.map((opt, optindex) => (
                                            <MenuItem key={optindex} value={opt.value}>
                                                {opt.show}
                                            </MenuItem>
                                        ))}
                                    </CustomSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {activeSpotlightProducts.length > 0 && !completed && !isOutlet ? (
                    <section
                        ref={spotlightSectionRef}
                        className={`${
                            isAuthenticated ? 'spotSection' : 'spotSection notAuth'
                        } spotlightSection-${spotlightPhase}`}
                        style={
                            spotlightHeight === null
                                ? undefined
                                : {
                                      height: spotlightPhase === 'collapsing' ? 0 : spotlightHeight,
                                  }
                        }
                    >
                        {projmainloading ? (
                            <Loader />
                        ) : (
                            <div className="spotLightBg searchCnt d-flex justify-content-start align-items-start ">
                                <div className="newDivSpotted customContainer">
                                    <div className="searchLt"></div>
                                    <div className="searchRt">
                                        {!completed && activeSpotlightProducts.length > 0 && (
                                            <h2 className="auctionWeek">
                                                {phrase.auction_of_the_week.toUpperCase()}
                                            </h2>
                                        )}
                                        <div className="spotlightAuction searchRt customContainer">
                                            {activeSpotlightProducts.length > 0 && (
                                                <div
                                                    key={activeSpotlightProducts[0].id}
                                                    className={`auction-of-the-week-container spotlightCard-${spotlightPhase}`}
                                                    onClickCapture={(event) => {
                                                        if (
                                                            [
                                                                'removing',
                                                                'exiting',
                                                                'collapsing',
                                                            ].includes(spotlightPhase) ||
                                                            awardStates[
                                                                activeSpotlightProducts[0].id
                                                            ]
                                                        ) {
                                                            event.preventDefault()
                                                            event.stopPropagation()
                                                        }
                                                    }}
                                                >
                                                    {spotlightRemovalNotice ? (
                                                        <div
                                                            className="auctionAwardNotice"
                                                            role="status"
                                                            aria-live="polite"
                                                        >
                                                            <span
                                                                className="material-icons"
                                                                aria-hidden="true"
                                                            >
                                                                star_border
                                                            </span>
                                                            <strong>
                                                                {phrase.removed_from_spotlight ||
                                                                    'Removed from spotlight'}
                                                            </strong>
                                                        </div>
                                                    ) : (
                                                        awardStates[
                                                            activeSpotlightProducts[0].id
                                                        ] && (
                                                            <div
                                                                className="auctionAwardNotice"
                                                                role="status"
                                                                aria-live="polite"
                                                            >
                                                                <span
                                                                    className="material-icons"
                                                                    aria-hidden="true"
                                                                >
                                                                    gavel
                                                                </span>
                                                                <strong>
                                                                    {closedNoticeText(
                                                                        activeSpotlightProducts[0]
                                                                            .id,
                                                                    )}
                                                                </strong>
                                                            </div>
                                                        )
                                                    )}
                                                    <Link
                                                        to={`/product/view/${activeSpotlightProducts[0].id}`}
                                                    >
                                                        <AuctionOfTheWeek
                                                            data={withUpdatedDates(
                                                                spotlightProduct?.id ===
                                                                    activeSpotlightProducts[0].id
                                                                    ? spotlightProduct
                                                                    : activeSpotlightProducts[0],
                                                            )}
                                                            phrase={phrase}
                                                            onClick={() =>
                                                                handleRedirectInternal(
                                                                    history,
                                                                    `/product/view/${activeSpotlightProducts[0].id}`,
                                                                )
                                                            }
                                                        />
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </section>
                ) : null}
                <div className="searchCnt searcf d-flex justify-content-start align-items-start customContainer">
                    <div className="searchLt">
                        {useCustomMediaQuery('(min-width: 1024px)') ? (
                            <div className="deskFilter">
                                <FilterPanel
                                    // setSearch={setSearch}
                                    clearSearch={clearSearchFilter}
                                    //search={search}
                                    page="search"
                                    from={1}
                                    searchFilterFunc={searchFilterFunc}
                                />
                                {!completed &&
                                    outletCount > 0 &&
                                    (() => {
                                        const ButtonComponent = isOutlet ? Button : PrimaryButton
                                        const auctionFormat = isOutlet ? 'normal' : 'outlet'
                                        const route = isOutlet ? '/search' : '/search/outlet'

                                        return (
                                            <ButtonComponent
                                                className="outletBtn"
                                                onClick={() => {
                                                    clearSearchFilter()
                                                    setProjectsMainPayload((prev) => ({
                                                        ...prev,
                                                        auction_format: auctionFormat,
                                                        page: 1,
                                                    }))
                                                    history.push(route)
                                                }}
                                            >
                                                <img
                                                    src="/assets/images/outlet_ledmax_btn1.png"
                                                    alt="Outlet"
                                                />
                                            </ButtonComponent>
                                        )
                                    })()}
                            </div>
                        ) : (
                            <Drawer
                                anchor="left"
                                open={state['left']}
                                className="responsiveFilterDrawer"
                                onClose={toggleDrawer('left', false)}
                                onOpen={toggleDrawer('left', true)}
                            >
                                <div
                                    className={clsx(classes.list, 'left')}
                                    role="presentation"
                                    // onClick={toggleDrawer('left', false)}
                                    onKeyDown={toggleDrawer('left', false)}
                                >
                                    <FilterPanel
                                        //setSearch={setSearch}
                                        clearSearch={clearSearchFilter}
                                        searchFilterFunc={searchFilterFunc}
                                        //search={search}
                                        from={1}
                                    />
                                </div>
                            </Drawer>
                        )}
                    </div>
                    {!completed ? (
                        <div className="searchRt">
                            {projmainloading ? (
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ minHeight: '300px' }}
                                >
                                    <Loader />
                                </div>
                            ) : activeProducts.length > 0 ? (
                                <div
                                    ref={resultsContainerRef}
                                    className={`searchResults ${auctionView}`}
                                >
                                    {displayedProducts.map((data) => (
                                        <React.Fragment key={data.id}>
                                            {auctionView === 'Grid' ? (
                                                <GridView
                                                    data={data}
                                                    closingNotice={closingNotice(data)}
                                                    favId={`searchProd_${data.id}`}
                                                    drawerHandler={toggleDrawer(
                                                        'right',
                                                        true,
                                                        data,
                                                    )}
                                                    isOutlet={isOutlet ? 'black' : undefined}
                                                />
                                            ) : (
                                                <ListView
                                                    data={data}
                                                    closingNotice={closingNotice(data)}
                                                    favId={`searchProd_${data.id}`}
                                                    drawerHandler={toggleDrawer(
                                                        'right',
                                                        true,
                                                        data,
                                                    )}
                                                    isOutlet={isOutlet ? 'black' : undefined}
                                                />
                                            )}
                                        </React.Fragment>
                                    ))}
                                </div>
                            ) : (
                                <div className="np-pro-box">
                                    <h5>{phrase.no_results_found}</h5>
                                </div>
                            )}

                            {totalRecordsForDisplay > projectsMainPayload.sh_limit &&
                                totalPages > 1 && (
                                    <div className="d-flex justify-content-between align-items-center flex-wrap w-100 my-3 pagination-wrapper">
                                        <Pagination
                                            count={totalPages}
                                            page={projectsMainPayload.page}
                                            onChange={onHandlePage}
                                            siblingCount={3}
                                            showFirstButton
                                            showLastButton
                                            boundaryCount={2}
                                        />
                                    </div>
                                )}
                        </div>
                    ) : (
                        <div className={`searchRt ${completed ? 'closedComp' : ''}`}>
                            {completed ? null : (
                                <>
                                    {selectedCategories &&
                                    Array.isArray(selectedCategories) &&
                                    selectedCategories.length ? null : (
                                        <Banner bannerList={bannerList} />
                                    )}
                                </>
                            )}
                            {completed ? null : (
                                <div className="grid-card-view">
                                    <div className="d-flex filterCnt align-items-center mb-3">
                                        <Button
                                            variant="outlined"
                                            className="showFilter"
                                            onClick={toggleDrawer('left', true)}
                                        >
                                            <span className="material-icons">tune</span>{' '}
                                            {phrase.filter_by || 'Filter By'}
                                        </Button>
                                    </div>
                                    <div className="showOutlet">
                                        {!completed &&
                                            outletCount > 0 &&
                                            (isOutlet ? (
                                                <Button
                                                    className="outletBtn"
                                                    onClick={() => {
                                                        clearSearchFilter()
                                                        setProjectsMainPayload((prev) => ({
                                                            ...prev,
                                                            auction_format: 'normal',
                                                            page: 1,
                                                        }))
                                                        history.push('/search')
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/images/outlet_ledmax_btn1.png"
                                                        alt="Outlet"
                                                    />
                                                </Button>
                                            ) : (
                                                <PrimaryButton
                                                    className="outletBtn"
                                                    onClick={() => {
                                                        clearSearchFilter()
                                                        setProjectsMainPayload((prev) => ({
                                                            ...prev,
                                                            auction_format: 'outlet',
                                                            page: 1,
                                                        }))
                                                        history.push('/search/outlet')
                                                    }}
                                                >
                                                    <img
                                                        src="/assets/images/outlet_ledmax_btn1.png"
                                                        alt="Outlet"
                                                    />
                                                </PrimaryButton>
                                            ))}
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center"></div>
                                </div>
                            )}
                            {showRecentlyClosedAuctionsSection && (
                                <div className="ml-3">
                                    <div className="mb-3 d-flex justify-content-start align-items-center">
                                        <div className="searchTitle" style={{ top: '8px' }}>
                                            {completed ? (
                                                <h3>{phrase.recently_closed_auctions}</h3>
                                            ) : null}
                                            <h6>
                                                {projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.set_disp}{' '}
                                                OF{' '}
                                                {projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.totalRecords}{' '}
                                                LOTS
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center"></div>
                                    {projcompletedloading ? (
                                        <Loader />
                                    ) : projectsMainCompleted.length ? (
                                        <>
                                            {projcompletedloading ? (
                                                <Loader />
                                            ) : (
                                                <div
                                                    className={`searchResults mt-4 ${auctionView}`}
                                                >
                                                    <Drawer
                                                        className="rightDrawer"
                                                        anchor={'right'}
                                                        open={state['right']}
                                                        onClose={toggleDrawer('right', false)}
                                                    >
                                                        {/* <ProductView data={state.data} /> */}
                                                    </Drawer>

                                                    {projectsMainCompleted.map((data, index) => (
                                                        <React.Fragment key={index}>
                                                            {auctionView === 'Grid' ? (
                                                                <>
                                                                    <GridView
                                                                        data={data}
                                                                        favId={`searchProd_${index}`}
                                                                        drawerHandler={toggleDrawer(
                                                                            'right',
                                                                            true,
                                                                            data,
                                                                        )}
                                                                        completed={true}
                                                                        fallbackAuctionFormat={
                                                                            isOutlet
                                                                                ? 'outlet'
                                                                                : undefined
                                                                        }
                                                                    />
                                                                </>
                                                            ) : (
                                                                <ListView
                                                                    data={data}
                                                                    favId={`searchProd_${index}`}
                                                                    drawerHandler={toggleDrawer(
                                                                        'right',
                                                                        true,
                                                                        data,
                                                                    )}
                                                                    completed={true}
                                                                    fallbackAuctionFormat={
                                                                        isOutlet
                                                                            ? 'outlet'
                                                                            : undefined
                                                                    }
                                                                />
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            )}
                                            <div
                                                className={`d-flex justify-content-${
                                                    completed ? 'between' : 'center'
                                                } align-items-center flex-wrap w-100 my-3 pagination-wrapper`}
                                            >
                                                {completed ? (
                                                    <Pagination
                                                        count={Math.ceil(
                                                            projectCompleted.totalRecords /
                                                                endedProjectsPayload.sh_limit,
                                                        )}
                                                        page={endedProjectsPayload.page}
                                                        onChange={onHandlePageEndedAuctions}
                                                        siblingCount={3}
                                                        showFirstButton
                                                        showLastButton
                                                        boundaryCount={2}
                                                    />
                                                ) : // <PrimaryButton
                                                //     label={`${phrase.view} ${phrase.recently_closed_auctions}`}
                                                //     onClick={() =>
                                                //         (window.location.href = '/search/completed')
                                                //     }
                                                // />
                                                null}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="np-pro-box">
                                            <h5>{phrase.no_results_found}!</h5>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {/* Mobile view filter Options */}
                <div className="searchRt mobile-view">
                    {completed ? null : (
                        <>
                            {selectedCategories &&
                            Array.isArray(selectedCategories) &&
                            selectedCategories.length ? null : (
                                <Banner bannerList={bannerList} />
                            )}
                        </>
                    )}
                    {completed ? null : (
                        <div className="grid-card-view">
                            <div className="d-flex filterCnt align-items-center mb-3">
                                <Button
                                    variant="outlined"
                                    className="showFilter"
                                    onClick={toggleDrawer('left', true)}
                                >
                                    <span className="material-icons">tune</span>{' '}
                                    {phrase.filter_by || 'Filter By'}
                                </Button>
                            </div>
                            <div className="showOutlet">
                                {!completed &&
                                    outletCount > 0 &&
                                    (isOutlet ? (
                                        <Button
                                            className="outletBtn"
                                            onClick={() => {
                                                clearSearchFilter()
                                                setProjectsMainPayload((prev) => ({
                                                    ...prev,
                                                    auction_format: 'normal',
                                                    page: 1,
                                                }))
                                                history.push('/search')
                                            }}
                                        >
                                            <img
                                                src="/assets/images/outlet_ledmax_btn1.png"
                                                alt="Outlet"
                                            />
                                        </Button>
                                    ) : (
                                        <PrimaryButton
                                            className="outletBtn"
                                            onClick={() => {
                                                clearSearchFilter()
                                                setProjectsMainPayload((prev) => ({
                                                    ...prev,
                                                    auction_format: 'outlet',
                                                    page: 1,
                                                }))
                                                history.push('/search/outlet')
                                            }}
                                        >
                                            <img
                                                src="/assets/images/outlet_ledmax_btn1.png"
                                                alt="Outlet"
                                            />
                                        </PrimaryButton>
                                    ))}
                            </div>
                            <div className="d-flex justify-content-between align-items-center"></div>
                        </div>
                    )}
                </div>
                {!completed && (
                    <div className="searchCnt searcf d-flex justify-content-start align-items-start customContainer">
                        <div className="searchLt"></div>
                        <div className={`searchRt ${completed ? 'closedComp' : ''}`}>
                            {completed ? null : (
                                <>
                                    {selectedCategories &&
                                    Array.isArray(selectedCategories) &&
                                    selectedCategories.length ? null : (
                                        <Banner bannerList={bannerList} />
                                    )}
                                </>
                            )}
                            {showRecentlyClosedAuctionsSection && (
                                <div className="ml-3">
                                    <div className="mb-3 d-flex justify-content-start align-items-center">
                                        <div className="searchTitle">
                                            {!completed ? (
                                                <h3>{phrase.recently_closed_auctions}</h3>
                                            ) : null}
                                            <h6>
                                                {recentlyClosedProducts.length
                                                    ? recentlyClosedSetDisp
                                                    : projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.set_disp}{' '}
                                                OF{' '}
                                                {recentlyClosedProducts.length
                                                    ? recentlyClosedTotal
                                                    : projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.totalRecords}{' '}
                                                LOTS
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center"></div>
                                    {recentlyClosedProducts.length ? (
                                        <>
                                            <div className={`searchResults mt-4 ${auctionView}`}>
                                                <Drawer
                                                    className="rightDrawer"
                                                    anchor={'right'}
                                                    open={state['right']}
                                                    onClose={toggleDrawer('right', false)}
                                                >
                                                    {/* <ProductView data={state.data} /> */}
                                                </Drawer>

                                                {recentlyClosedProducts.map((data, index) => (
                                                    <React.Fragment
                                                        key={getProductId(data) || index}
                                                    >
                                                        {auctionView === 'Grid' ? (
                                                            <GridView
                                                                data={data}
                                                                favId={`searchProd_${index}`}
                                                                drawerHandler={toggleDrawer(
                                                                    'right',
                                                                    true,
                                                                    data,
                                                                )}
                                                                completed={true}
                                                                fallbackAuctionFormat={
                                                                    isOutlet ? 'outlet' : undefined
                                                                }
                                                            />
                                                        ) : (
                                                            <ListView
                                                                data={data}
                                                                favId={`searchProd_${index}`}
                                                                drawerHandler={toggleDrawer(
                                                                    'right',
                                                                    true,
                                                                    data,
                                                                )}
                                                                completed={true}
                                                                fallbackAuctionFormat={
                                                                    isOutlet ? 'outlet' : undefined
                                                                }
                                                            />
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                            <div
                                                className={`d-flex justify-content-${
                                                    completed ? 'between' : 'center'
                                                } align-items-center flex-wrap w-100 my-3 pagination-wrapper`}
                                            >
                                                {completed ? (
                                                    <Pagination
                                                        count={Math.ceil(
                                                            projectCompleted.totalRecords /
                                                                endedProjectsPayload.sh_limit,
                                                        )}
                                                        page={endedProjectsPayload.page}
                                                        onChange={onHandlePageEndedAuctions}
                                                        siblingCount={3}
                                                        showFirstButton
                                                        showLastButton
                                                        boundaryCount={2}
                                                    />
                                                ) : // <PrimaryButton
                                                //     label={`${phrase.view} ${phrase.recently_closed_auctions}`}
                                                //     onClick={() =>
                                                //         (window.location.href = '/search/completed')
                                                //     }
                                                // />
                                                null}
                                            </div>
                                        </>
                                    ) : projcompletedloading ? (
                                        <Loader />
                                    ) : (
                                        <div className="np-pro-box">
                                            <h5>{phrase.no_results_found}!</h5>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* PRODUCT VIEW DRAWER */}
            </div>
        </>
    )
}
export default Search
